export default class valueBox {
    constructor() {

        function close(valueItem, detailBox) {
            detailBox.forEach(function (i) {
                i.classList.remove("act");
            })
            valueItem.forEach(function (i) {
                i.classList.remove("act");
            })

        }

        const valueBox = document.querySelector(".valueBox");
        const inner = document.querySelectorAll(".valueBox > .inner");

        inner.forEach(function (i) {
            const valueItem = i.querySelectorAll(".valueItem");
            const detailBox = i.querySelectorAll(".detailBox");

            valueItem.forEach(function (q, index) {
                q.addEventListener("click", function () {
                    if (q.classList.contains("act")) {
                        close(valueItem, detailBox);

                    } else {
                        close(valueItem, detailBox);
                        q.classList.add("act")
                        detailBox[index].classList.add("act")
                    }
                })
            })
        })
    }
}